import { cn } from '@/lib/utils/cn';
import type { AutosaveStatus } from '@/hooks/useDebouncedAutosave';

const LABEL: Record<AutosaveStatus, string> = {
  idle: '',
  unsaved: 'Unsaved changes',
  saving: 'Saving…',
  saved: 'Saved',
  error: 'Save failed',
};

const TONE: Record<AutosaveStatus, string> = {
  idle: 'text-transparent',
  unsaved: 'text-ink-500 dark:text-ink-400',
  saving: 'text-ink-500 dark:text-ink-400',
  saved: 'text-emerald-600 dark:text-emerald-400',
  error: 'text-rose-600 dark:text-rose-400',
};

/**
 * Calm status pill the autosave hook drives. Always reserves space so
 * the layout doesn't jump as the label changes.
 */
export function AutosaveIndicator({
  status,
  className,
}: {
  status: AutosaveStatus;
  className?: string;
}) {
  return (
    <span
      aria-live="polite"
      className={cn(
        'inline-flex items-center gap-1.5 text-xs font-medium tracking-tight',
        'min-w-[7rem]',
        TONE[status],
        className,
      )}
    >
      {status !== 'idle' && (
        <span
          aria-hidden="true"
          className={cn(
            'inline-block h-1.5 w-1.5 rounded-full bg-current',
            status === 'saving' && 'animate-pulse',
          )}
        />
      )}
      {LABEL[status] || ' '}
    </span>
  );
}
